import { render, staticRenderFns } from "./detailRelevancyQue.vue?vue&type=template&id=32f2bfb7&scoped=true&"
import script from "./detailRelevancyQue.vue?vue&type=script&lang=js&"
export * from "./detailRelevancyQue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f2bfb7",
  null
  
)

export default component.exports